import { focusVisible } from "@mittwald/flow-styles/dist/mixins/focusVisible";
import { color, duration, size, } from "@mittwald/flow-styles/dist/tokens/ts/variables";
import { css } from "styled-components";
const general = css `
  // required for rendering as link
  display: inline-grid;
  border: none;
  border-radius: ${size.borderRadius};
  outline: none;
  overflow: hidden;
  font-size: ${size.font.button};
  font-weight: bold;
  line-height: ${size.lineHeight.text.default};
  cursor: pointer;
  width: fit-content;

  transition:
    background ${duration.animation.fast}ms ease,
    color ${duration.animation.fast}ms ease;

  &:disabled {
    cursor: not-allowed;
  }

  color: ${color.font.text.default};
  background: ${color.background.default};

  ${focusVisible}
  &.focus,
  &:focus-visible {
    outline-offset: 2px;
  }
`;
const info = css `
  color: ${color.font.button.continue.default};
  background: ${color.background.button.continue.default};

  &.hover,
  &:hover {
    color: ${color.font.button.continue.hover};
    background: ${color.background.button.continue.hover};
  }

  &.active,
  &:active {
    color: ${color.font.button.continue.active};
    background: ${color.background.button.continue.active};
  }

  &:disabled {
    color: ${color.font.button.continue.disabled};
    background: ${color.background.button.continue.disabled};
  }
`;
const ok = css `
  color: ${color.font.button.complete.default};
  background: ${color.background.button.complete.default};

  &.hover,
  &:hover {
    color: ${color.font.button.complete.hover};
    background: ${color.background.button.complete.hover};
  }

  &.active,
  &:active {
    color: ${color.font.button.complete.active};
    background: ${color.background.button.complete.active};
  }

  &:disabled {
    color: ${color.font.button.complete.disabled};
    background: ${color.background.button.complete.disabled};
  }
`;
const destructive = css `
  color: ${color.font.button.destructive.default};
  background: ${color.background.button.destructive.default};

  &.hover,
  &:hover {
    color: ${color.font.button.destructive.hover};
    background: ${color.background.button.destructive.hover};
  }

  &.active,
  &:active {
    color: ${color.font.button.destructive.active};
    background: ${color.background.button.destructive.active};
  }

  &:disabled {
    color: ${color.font.button.destructive.disabled};
    background: ${color.background.button.destructive.disabled};
  }
`;
const cancel = css `
  color: ${color.font.button.cancel.default};
  background: ${color.background.button.cancel.default};

  &.hover,
  &:hover {
    color: ${color.font.button.cancel.hover};
    background: ${color.background.button.cancel.hover};
  }

  &.active,
  &:active {
    color: ${color.font.button.cancel.active};
    background: ${color.background.button.cancel.active};
  }

  &:disabled {
    color: ${color.font.button.cancel.disabled};
    background: ${color.background.button.cancel.disabled};
  }
`;
const iconOnly = css `
  &.cancel {
    background: none;
    color: ${color.font.button.link.default};

    &.hover,
    &:hover {
      background: ${color.status.info.backgroundLight};
    }

    &.active,
    &:active {
      background: ${color.status.info.backgroundDark};
    }

    &:disabled {
      color: ${color.font.button.link.disabled};
      background: none;
    }
  }
`;
export const buttonBaseStyle = css `
  ${general};

  &.info {
    ${info};
  }

  &.ok {
    ${ok};
  }

  &.destructive {
    ${destructive};
  }

  &.cancel {
    ${cancel};
  }

  &.iconOnly {
    ${iconOnly};
  }
`;
export default buttonBaseStyle;
//# sourceMappingURL=data:application/json;base64,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